import BaseModel from "@/api/models/BaseModel";

/**
 * MaterialDictionary
 */
export default class MaterialDictionary extends BaseModel {
    
    constructor() {
        super();

        this.BASIC_I = 1;
        this.BASIC_II = 2;
        this.INTERMEDIATE_I = 3;
        this.INTERMEDIATE_II = 4;
        this.ADVANCED_I = 5;
        this.ADVANCED_II = 6;
        this.CONVERSATION = 7;
        this.TEEN_I = 8;
    }

    /**
     * Gets all Material statuses
     * @returns {Array<{label: String, value: String}>}
     */
    getAll(ignore = []) {
        return [
            { label: 'basic I', value: this.BASIC_I },
            { label: 'basic II', value: this.BASIC_II },
            { label: 'intermediate I', value: this.INTERMEDIATE_I },
            { label: 'intermediate II', value: this.INTERMEDIATE_II },
            { label: 'advanced I', value: this.ADVANCED_I },
            { label: 'advanced II', value: this.ADVANCED_II },
            { label: 'conversation', value: this.CONVERSATION },
            { label: 'teen I', value: this.TEEN_I }
        ].filter(item => !ignore.includes(item.value));
    }

    /**
     * Gets label for a given Material status value
     * @param {String} value
     * @returns {String}
     */
    getLabel(value) {
        const all = this.getAll();

        let label = '';
        for (let item of all) {
            if (parseInt(item.value) === parseInt(value)) {
                label = item.label;
                break;
            }
        }

        return label || '';
    }

    /**
     * Gets all data of Status
     * @param {String} value
     * @returns {Object}
     */
    getItem(value) {
        const all = this.getAll();

        for (let item of all) {
            if (parseInt(item.value) === parseInt(value)) {
                return item;
            }
        }

        return null;
    }
}